module.exports = __webpack_public_path__ + "img/header-img.24577dfc.png";